import { render, staticRenderFns } from "./LiveClassTab.vue?vue&type=template&id=520e2418&"
import script from "./LiveClassTab.vue?vue&type=script&lang=js&"
export * from "./LiveClassTab.vue?vue&type=script&lang=js&"
import style0 from "./LiveClassTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LiveClassTab.vue"
export default component.exports